import { computed } from 'vue'

import type { ComputedRef } from 'vue'

import { useTutorKanbanStore } from './store'
import { useTutorKanbanSelectReason } from './tutor-kanban-select-reason.hook'
import { useTutorKanbanSave } from './tutor-kanban-save.hook'

interface TutorKanbanReasonConfirmReturn {
  isConfirmOpen: ComputedRef<boolean>
  setConfirmChange: () => Promise<void>
  setCancelChange: () => Promise<void>
}

export const useTutorKanbanReasonConfirm = (): TutorKanbanReasonConfirmReturn => {
  const tutorKanbanStore = useTutorKanbanStore()
  const reason = useTutorKanbanSelectReason()
  const { setSubmitUpdate } = useTutorKanbanSave()

  const isConfirmOpen = computed<boolean>(() => reason.isConfirmOpen.value)

  const setConfirmChange = async (): Promise<void> => {
    const isRequestedBySave = tutorKanbanStore.getReasonConfirmSource === 'save'

    reason.setConfirmChange()

    if (isRequestedBySave) {
      await setSubmitUpdate()
    }
  }

  const setCancelChange = async (): Promise<void> => {
    const isRequestedBySave = tutorKanbanStore.getReasonConfirmSource === 'save'

    reason.setCancelChange()

    if (isRequestedBySave) {
      await setSubmitUpdate()
    }
  }

  return {
    isConfirmOpen,
    setConfirmChange,
    setCancelChange,
  }
}
